export const isLocalhost = () => {

    if(
        window.location.href.includes('localhost') ||
        window.location.href.includes('127.0.0.1')
    ){
        return true;
    }
    else{
        return false;
    }
}

export const isInternal = () => {

    if(window.location.href.includes('192.168.')){
        return true;
    }
    else{
        return false;
    }
}

export const isDemo = () => {

    if(window.location.href.includes('frontenddemo.') || window.location.href.includes('vigeprademo.')){
        return true;
    }
    else{
        return false;
    }
}

export const isTest = () => {

    if(window.location.href.includes('frontendtest.') || window.location.href.includes('vigepratest.')){
        return true;
    }
    else{
        return false;
    }
}

export const isProd = () => {

    if(window.location.href.includes('frontend.') || window.location.href.includes('vigepra.')){
        return true;
    }
    else{
        return false;
    }
}

export const getServerType = () => {

    var type = '';

    if(isLocalhost()){
        type = 'LOCAL';
    }
    else{
        if(isDemo()){
            type = 'DEMO';
        }
        else{
            if(isProd()){
                type = 'PROD';
            }
            else{
                if(isTest()){
                    type = 'TEST';
                }
            }
        }
    }

    return type;
}

export const backendApi = () => {

    var backend = null;
    var backendApi = null;

    if(isDemo()){
        backend = import.meta.env.VITE_BACKEND_DEMO;
    }
    else{
        if(isProd()){
            backend = import.meta.env.VITE_BACKEND_PROD;
        }
        else{
            if(isTest()){
                backend = import.meta.env.VITE_BACKEND_TEST;
            }
            else{                
                if(isInternal()){
                    backend = import.meta.env.VITE_BACKEND_INTERN;
                }
                else{
                    // isLocalhost()
                    // by default localhost
                    backend = import.meta.env.VITE_BACKEND_LOCAL;
                }
            }
        }
    }

    if(backend){
        backendApi = backend+import.meta.env.VITE_API_PATH;
    }

    return backendApi;
}

// clean the path removing ending /
export const cleanPath = (path) => {

    var clean = path;
    
    // do not replace if root
    if(path !== '/'){
        clean = path.replace(/\/$/,'');
    }

    return clean;
}

// clean leading slash for internal menu and selection references
export const getCleanPath = (path) => {
    return path ? (path.startsWith('/') ? path.substring(1) : path) : '';
}

// get url path to change the url when choosing a menu
export const getPathURL = (path) => {

    var urlPath = path;

    // if forgot password and already logged in, go to profile   
    switch(path){

        case '/forgot':
            urlPath = 'profile';
            break;
    }

    return urlPath;
}

// get parameter from url
export const getParameterURL = (router,name) => {
    const params = router.searchParams;
    return params.get(name);   
}

// get parameters from url
// array of names
export const getParametersURL = (router = null, names = null) => {

    let params;
    if(!router){
        params = new URLSearchParams(window.location.search);
    }
    else{        
        params = router.searchParams;
    }

    var result = {}

    // if array of names, get them. if not, get all
    if(names){
        if(Array.isArray(names) && names?.length > 0){
            names?.forEach((name) => {
                result[name] = params.get(name);
            });
        }
        else{
            // names is a string
            result[names] = params.get(names);
        }
    }
    else{
        result = Object.fromEntries(params.entries());
    }

    // if only one name, return directly its value
     if(names){
        if(Array.isArray(names)){
            if(names?.length === 1){
                return result[names[0]];
            }
            else{
                return result;
            }
        }
        else{
            // names is a string
            return result[names];
        }
    }    
    else{
        return result;
    }
}

// remove parameter from url
export const removeParameterURL = (path,params,parameter) => {

    params.delete(parameter);

    const newQueryString = params.toString();

    if(newQueryString){
        return `${path}?${newQueryString}`;
    }

    // if no parameters, return path
    return path;
}

// remove multiple parameters from url
// parameters = ['filter', 'resource']
export const removeParametersURL = (path, params, parameters) => {

    if(Array.isArray(parameters)){
        parameters.forEach((parameter) => params.delete(parameter));
    }
    else{
        params.delete(parameters);
    }

    const newQueryString = params.toString();

    if(newQueryString){
        return `${path}?${newQueryString}`;
    }

    return path;
}

// add parameter to url
export const addParameterURL = (router = null, path = null, params = null, parameter = null, value = null, replace = true) => {

    let pathvalue;
    if(!path){
        if(router){
            pathvalue = router?.pathname;
        }
        else{
            pathvalue = window.location.pathname;
        }
    }
    else{
        pathvalue = path;
    }

    if(!pathvalue){
        return null;
    }

    let paramsvalue;
    if(!params){
        if(router){
            paramsvalue = router.searchParams;
        }
        else{
            paramsvalue = new URLSearchParams();
        }
    }
    else{
        paramsvalue = params;
    }

    if(!paramsvalue){
        return pathvalue;
    }

    // if empty value, remove
    if(value === null || typeof value === 'undefined' || value === ''){
        paramsvalue.delete(parameter);
    }
    else{
        // if replace, replace same param if already there
        if(replace){
            paramsvalue.set(parameter,value);
        }
        else{
            paramsvalue.append(parameter,value);
        }
    }

    const newQueryString = paramsvalue.toString();

    if(newQueryString){
        return `${pathvalue}?${newQueryString}`;
    }

    // if no parameters, return path
    return pathvalue;
}

// add parameters to url
// parameters = {cat:1,create:1}
export const addParametersURL = (router = null, path = null, params = null, parameters = null,replace = true) => {

    let pathvalue;
    if(!path){
        if(router){
            pathvalue = router?.pathname;
        }
        else{
            pathvalue = window.location.pathname;
        }
    }
    else{
        pathvalue = path;
    }

    if(!pathvalue){
        return null;
    }

    let paramsvalue;
    if(!params){
        if(router){
            paramsvalue = router.searchParams;
        }
        else{
            paramsvalue = new URLSearchParams();
        }
    }
    else{
        paramsvalue = params;
    }

    if(!paramsvalue){
        return pathvalue;
    }

    if(parameters){

        Object.keys(parameters)?.forEach((name) => {

            // if empty value, remove
            if(!parameters[name] || parameters[name].length === 0){
                paramsvalue.delete(name);
            }
            else{

                // if replace, replace same param if already there
                if(replace){
                    paramsvalue.set(name,parameters[name]);
                }
                else{
                    paramsvalue.append(name,parameters[name]);
                }
            }
        });

        const newQueryString = paramsvalue.toString();

        if(newQueryString){
            return `${pathvalue}?${newQueryString}`;
        }                    
    }

    // if no parameters, return path
    return pathvalue;
}

// add parameter to open a new ticket
export const goTicketURL = (router,menuConfig, clean = true) => {

    let ticketsPath = null;
    if(menuConfig && Object?.keys(menuConfig)?.length > 0){
    
        const ticketKey = Object?.keys(menuConfig)?.find((key) => menuConfig[key]?.segment === 'tickets');
        if(ticketKey){
            ticketsPath = menuConfig[ticketKey]?.path;
        }
    }

    if(!ticketsPath){
        return null;
    }

    var path = '/'+ticketsPath;

    // if clean is false, we preserve the previous params
    let params;
    if(clean){
        params = new URLSearchParams();
    }
    else{
        params = router.searchParams;
    }

    const variables = {
        'create': 1
    };        

    path = addParametersURL(null,path,params,variables);
    
    return router?.navigate(path);
}

// generate url for the project
export const getProjectUrl = (project) => {

    var url = '';

    if(project?.city && project.city?.length > 0){
        url += project?.city+',';
    }

    if(project?.province && project.province?.length > 0){
        url += project?.province+',';
    }

    if(project?.country?.name && project.country.name.length > 0){
        url += project.country.name;
    }

    if(url && url?.length > 0){
        const query = encodeURIComponent(url); 
        const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${query}&z=20`;
        url = googleMapsUrl;
    }

    return url;
}

/**
 * Normalizes a URL value based on its type. 
 * Handles email (mailto:), phone (tel:) and links (https:// or relative).
 * @param {string} value 
 * @param {string} type - 'email', 'phone', 'link' or 'linkshort'
 * @returns {string}
 */
export const getLink = (value, type = 'link') => {
    let href = value;
    
    switch(type){
        case 'email':
            href = value && !String(value).startsWith('mailto:') ? `mailto:${String(value).trim()}` : value;
            break;
        case 'phone':
            href = value && !String(value).startsWith('tel:') ? `tel:${String(value).trim()}` : value;
            break;
        case 'link':
        case 'linkshort':
        default:
            if(value && !String(value).startsWith('http') && !String(value).startsWith('//') && !String(value).startsWith('/')){
                href = `https://${String(value).trim()}`;
            }
            break;
    }
    
    return href;
}